import React, { useEffect, useState } from "react";
import { Route, useNavigate } from "react-router-dom";
import { _common } from "../common";
import { ServerInterface } from "../ServerInterface";
const common = _common;

const ProtectedRoute = (props: {
  children: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined;
}) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  async function checkUserToken() {
    let user = JSON.parse(common.getUserFromLocalStorage());
    if (!user || !user.memberId) {

      setIsLoggedIn(false);
      return navigate("/login");
    }


    //
    // MWE: neu ab 2025:
    //   Prüfung der Registierung/Login bei jedem Start der App
    //

    var registerInfo = {
      email: user.email,
      memberId: user.memberId,
      pin: user.pin,
    };

    const data = await ServerInterface.register(registerInfo);
    if (!data || !data.memberId) {
      setIsLoggedIn(false);
      return navigate("/login");
    }

    //
    // MWE: neu ab 2025:
    //   Prüfung ob ein ProfilImage angelegt wurde.
    //


    user = JSON.parse(common.getUserFromLocalStorage());
    const src = `${ServerInterface.serverUrl}/booking/profileImage/?memberId=${user.memberId}`;
    if (!src) {
      return navigate("/profile");
    }



    setIsLoggedIn(true);
  };

  useEffect(() => {
    if (window.location.href.toLocaleLowerCase().indexOf("display") < 0) {
      checkUserToken();
    }
  }, [isLoggedIn]);

  //
  // no login needed for display
  //
  if (window.location.href.toLocaleLowerCase().indexOf("display") >= 0) {
    common.anzeigeTafelMode = true;
    return <React.Fragment>{props.children}</React.Fragment>;
  } else {
    return <React.Fragment>{isLoggedIn ? props.children : null}</React.Fragment>;
  }
};
export default ProtectedRoute;
